import { Component, useContext } from 'react';
import { TenantContext, TenantContextState } from 'context/TenantContext';
import { Alert, Button } from 'reactstrap';
import { Loader } from 'components/Loader';
import { adminConsent } from 'logic/adminConsent';

import css from '../TabConsent.module.scss';

const adminConsentType = "Attest";

type TabConsentAttestInternalProps = {
    tenantContext: TenantContextState
}

class TabConsentAttestInternal extends Component<TabConsentAttestInternalProps, {}> {
    redirect = () => {
        var appId = this.props.tenantContext.getAdminConsentAppId(adminConsentType);
        adminConsent.redirect(adminConsentType, appId);
    }
    
    renderContent = () => {
        let contentRendered;
        if (!this.props.tenantContext.isAdminConsentGranted(adminConsentType)) {
            // Only show the Admin Consent button when the admin consent has not been granted yet.
            contentRendered = 
                <>
                    <Alert color="warning">
                        The ATTEST services needs to be granted a limited set of access rights to your Azure environment to function correctly.
                        These rights have to be provided by an administrator of your organization.
                    </Alert>
                    <p>By clicking the button below, you will be redirected to Microsoft to grant consent.</p>
                    <Button color="primary" className="mb-3" onClick={this.redirect}>Provide admin consent</Button>
                    <br/>
                    <br/>
                    <br/>
                    <p>When no consent is given consult the following <a href='https://support.cybertwice.com/knowledgebase.php?article=56' target='_blank' rel='noreferrer'>knowledgebase article</a></p>
                </>
        } else {
            contentRendered = 
                <Alert color="success">
                    Admin consent has been provided for the ATTEST base service.
                </Alert>
        }

        return <div className={css.tabConsent}>
            <h2 className="my-3">ATTEST base access</h2>
            {contentRendered}  
        </div>
    }
  
    render() {
        return <Loader isLoading={!this.props.tenantContext.isTenantInfoRetrieved} showApiError={false} render={this.renderContent} />
    }
}

// Inject the required contexts.
export const TabConsentAttest = (props: any) => {
    const tenantContext = useContext(TenantContext);

    return (
        <TabConsentAttestInternal {...props} tenantContext={tenantContext}/>
    )
}